import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useReveal } from '../../../hooks/useReveal';

export default function CTASection() {
  const ref = useReveal();
  const { t } = useTranslation();

  return (
    <section ref={ref} className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="reveal bg-navy rounded-2xl p-8 lg:p-16 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-silver/5 rounded-full -translate-y-1/2 translate-x-1/3 pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-silver/5 rounded-full translate-y-1/2 -translate-x-1/3 pointer-events-none" />
          <div className="relative z-10 flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <p className="text-xs font-sans text-silver/50 tracking-[0.2em] uppercase mb-4">{t('cta.eyebrow')}</p>
              <h2 className="font-serif text-white text-3xl lg:text-4xl font-bold mb-3">
                {t('cta.heading')}
              </h2>
              <p className="text-white/60 font-sans text-base max-w-xl">
                {t('cta.desc')}
              </p>
            </div>
            <div className="flex flex-col gap-3 lg:ml-12 lg:min-w-[180px]">
              <Link
                to="/contact"
                className="px-8 py-4 bg-white text-navy text-sm font-sans font-semibold hover:bg-silver-light transition-all duration-300 rounded whitespace-nowrap cursor-pointer text-center"
              >
                {t('cta.primary')}
              </Link>
              <Link
                to="/services"
                className="px-8 py-4 border border-silver/40 text-silver text-sm font-sans font-medium hover:bg-white/10 transition-all duration-300 rounded whitespace-nowrap cursor-pointer text-center"
              >
                {t('cta.secondary')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
